import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetExtractRefreshSchedulingForDatasourceParams {
  id: string;
}

export interface IGetExtractRefreshSchedulingForDatasourceResult extends IResult{
  allowed: boolean;
  reason: string;
}

export class GetExtractRefreshSchedulingForDatasourceRequest extends Request<IGetExtractRefreshSchedulingForDatasourceParams, IGetExtractRefreshSchedulingForDatasourceResult> {
  constructor(params: IGetExtractRefreshSchedulingForDatasourceParams) {
    super('getExtractRefreshSchedulingForDatasource', params);
  }
}
